import React, { useState, useEffect } from 'react';
import PropertyWizard from './propertyForm/PropertyWizard';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { showToast } from '../../../components/common/notification/Notification';
import { useNavigate } from "react-router-dom";

const EditPropertyItem = () => {
  const navigate = useNavigate();
  
  const loggedInUser = useSelector((state) => state.auth.user);
  // const token = loggedInUser?.token;
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;
  const { Id } = useParams();

  const [propertyForm, setPropertyForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // JSON snapshot of the form as loaded, used to detect unsaved changes
  const [loadedSnapshot, setLoadedSnapshot] = useState(null);

  useEffect(() => {
    const fetchProperty = async () => {
      try { 
        const response = await axios.get(`${baseUrl}/property/propertyDetail/${Id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const property = response.data.propertyInfo;

        const loadedForm = {
          city: property.city.id || "",
          cityName: property.city.name || "",
          state: property.state.id || "",
          stateName: property.state.name || "",
          area: property.area_name || "",
          propertyType: property.type.id || "",
          propertyTypeName: property.type.name || "",
          propertyPurpose: property.purpose.id || "",
          propertyPurposeName: property.purpose.name || "",
          propertyStatus: property.status.id || "",
          propertySubtype: property.property_sub_type.id || "",
          propertySubtypeName: property.property_sub_type.name || "",
          propertySubSubType: property.property_sub_sub_type?.id || "",
          propertySubSubTypeName: property.property_sub_sub_type?.name || "",
          structure: property.structure || {},
          feature: property.feature || {}, 
          images: property.images
            ? property.images.map(img => ({
                ...img,
                url: assetUrl + img.image_url,
              }))
            : [],
          videos: property.videos
            ? property.videos.map(video => ({
                ...video,
                url: assetUrl + video.url_path,
              }))
            : [],
          attachments: property.attachments
            ? property.attachments.map(att => ({
                ...att,
                url: assetUrl + att.attachment_url,
              }))
            : [], 
          tags: property.tags || "",
          name: property.name || "",
          description: property.description || "",
          address: property.address || "",
          land_mark: property.land_mark || "",
          pin_code: property.pin_code || "",
          price: property.price || "",
          landType: property.landType.id || "",
          landTypeName: property.landType.name || "",
          are: property.are || "", 
          loanAvailability: property.loan_availability || false,
          // No longer editable in the form, but kept so saving does not reset it
          featured_property: property.featured_property, 
        };
        setPropertyForm(loadedForm);
        setLoadedSnapshot(JSON.stringify(loadedForm));
      } catch (error) {
        console.error("Failed to fetch property:", error);
        showToast('Failed to load property', { type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchProperty();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id, assetUrl, baseUrl, token]);

const handleSubmit = async () => {
  if (isSubmitting) return;
  setIsSubmitting(true);
  const images = (propertyForm.images || []).map((img) => ({
    imagePath: img.name || img.imagePath || "",
    // image_url: (img.url || "").replace(assetUrl, ""),
  }));

  const attachments = (propertyForm.attachments || []).map((attachment) => ({
    attachmentPath: attachment.name || attachment.attachmentPath || "",
    // attachment_url: (attachment.url || "").replace(assetUrl, ""),
  }));

  const videos = [{}];
  // const videos = (propertyForm.videos || []).map((video) => ({
  //   videoPath: video.name || video.videoPath || "",
  //   // url_path: (video.url || "").replace(assetUrl, ""),
  // }));

  const payload = {
    // title to be changed to name 
    // are gets null
    // budget gets null and better change it to price
    name: propertyForm.name || "",
    are: propertyForm.are || "",
    price: propertyForm.price || "",

    
    id: propertyForm.id || parseInt(Id),
    title: propertyForm.name || "", 
    description: propertyForm.description || "",
    budget: propertyForm.price || "", 
    purpose_id: propertyForm.propertyPurpose || null,
    type_id: propertyForm.propertyType || null,
    sub_type_id: propertyForm.propertySubtype || null,
    sub_sub_type_id: propertyForm.propertySubSubType || null,
    // Not shown in the form any more; the backend resets it to false when missing, so the
    // stored value is sent back unchanged.
    featured_property: propertyForm.featured_property,
    city_name: propertyForm.cityName || "",
    state_name: propertyForm.stateName || "", 
    country_name: "India",
    area_name: propertyForm.area || "", 
    property_status_id: propertyForm.propertyStatus || 1,
    // structure: { id: propertyForm.structure.id || "" },
    structure: { id: parseInt(Id) || "" },
    // feature: { id: propertyForm.feature.id || "" },
    feature: { id: parseInt(Id) || "" },
    images,
    attachments,
    videos,
    tags: propertyForm.tags || "",
    address: propertyForm.address || "",
    land_mark: propertyForm.land_mark || "",
    pin_code: propertyForm.pin_code || "",
    land_type_id: propertyForm.landType, 
    loan_availability: propertyForm.loanAvailability,
    // eslint-disable-next-line no-dupe-keys
    are: propertyForm.are,
  };
  try {
    const response = await axios.put(`${baseUrl}/property/editProperty`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 && response.data.statusType === 'SUCCESS') {
      showToast('Property edited successfully' , { type: 'success' });
      // isSubmitting stays true until the redirect, which also lifts the unsaved-changes warning
      setTimeout(() => {
        navigate("/property");
      }, 2000);
    } else {
      setIsSubmitting(false);
      showToast(response.data?.text || 'Failed to edit Property data', { type: 'error' });
    }
  } catch (error) {
    setIsSubmitting(false);
    showToast('Failed to edit Property data', { type: 'error' });
    console.error("Error updating property:", error);
  }
};

  return (
    <PropertyWizard
      mode="edit"
      form={propertyForm}
      setForm={setPropertyForm}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      loading={loading}
      isDirty={loadedSnapshot !== null && JSON.stringify(propertyForm) !== loadedSnapshot}
    />
  );
};

export default EditPropertyItem;
